import { has } from 'lodash';
import { ACTIONS } from '../Constants';

const getInitialState = () => ({
    byId: {},
    filteredById: {},
    sortOrder: []
});

export default (state = getInitialState(), action) => {
    let newById;
    let globalSectionItem;
    let reduced;
    switch (action.type) {
        case ACTIONS.PUT_GLOBAL_SECTION_ITEM_SUCCESS:
        case ACTIONS.POST_GLOBAL_SECTION_ITEM_SUCCESS:
        case ACTIONS.GET_GLOBAL_SECTION_ITEM: {
            ({ globalSectionItem } = action.payload);

            newById = {
                ...state.byId
            };

            if (has(globalSectionItem, '_id')) {
                if (globalSectionItem.isDeleted) {
                    newById[globalSectionItem._id] = undefined;
                } else {
                    newById[globalSectionItem._id] = globalSectionItem;
                }
            }

            return {
                ...state,
                byId: newById
            };
        }
        case ACTIONS.GET_MANY_GLOBAL_SECTION_ITEMS: {
            newById = {
                ...state.byId
            };

            reduced = (action.payload.globalSectionItems || []).forEach((globalSectionItem) => {
                newById[globalSectionItem._id] = {
                    ...newById[globalSectionItem._id],
                    ...globalSectionItem
                };
            });

            return {
                ...state,
                byId: newById
            };
        }

        case ACTIONS.GET_FILTERED_GLOBAL_SECTION_ITEMS:
            reduced = (action.payload.globalSectionItems || []).reduce((prev, globalSectionItem) => {
                prev[globalSectionItem._id] = globalSectionItem;
                return prev;
            }, {});

            newById = {
                ...state.byId,
                ...reduced
            };

            return {
                ...state,
                byId: newById,
                filteredById: reduced
            };

        case ACTIONS.POST_SEARCHED_GLOBAL_SECTION_ITEMS:
            reduced = (action.payload.globalSectionItems || []).reduce((prev, globalSectionItem) => {
                prev[globalSectionItem._id] = globalSectionItem;
                return prev;
            }, {});

            newById = {
                ...state.byId,
                ...reduced
            };
            return {
                ...state,
                byId: newById,
                filteredById: reduced,
                sortOrder: action.payload.sortOrder
            };

        case ACTIONS.CLEAR_SEARCHED_GLOBAL_SECTION_ITEMS:
            return {
                ...state,
                filteredById: {}
            };

        default:
            return state;
    }
};
